 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();



export const getContacts = async () => {
  try {
    const response = await authenticatedFetch(`${config.API_BASE_URL}/contacts`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      }
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else {
      throw new Error(`Error getting contacts: ${response.status}`);
    }
  } catch (error) {
   
    throw new Error(`Error getting contacts: ${error.message}`);
  }
};

export const getContact = async (contactID) => {
  try {
    if (!contactID) {
      throw new Error('Contact ID is required');
    }
   

    const response = await authenticatedFetch(`${config.API_BASE_URL}/contact/${contactID}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      },
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else {
      throw new Error(`Error getting contact: ${response.status}`);
    }
  } catch (error) {
  
    throw new Error(`Error getting contact: ${error.message}`);
  }
};

export const getContactsByCommunicationDetail = async (mobile, email,source) => {
  try {
    let requestBody = {};

    if (source === 'email') {
      requestBody.email = email;
    } else {
      requestBody.mobile = mobile;
    }
    const response = await authenticatedFetch(`${config.API_BASE_URL}/contactsbycommunicationDetail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      },
      body: JSON.stringify(requestBody),
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else {
      // Return status code for non-ok responses (as per original code)
      return response.status;
    }
  } catch (error) {
   
    throw new Error(`Error getting contacts by communication detail: ${error.message}`);
  }
};

export const getContactsByFirstLastName = async (firstName, lastName) => {
  try {
    if (!firstName || !lastName) {
      throw new Error('Both firstName and lastName are required');
    }

    const response = await authenticatedFetch(`${config.API_BASE_URL}/contactsbyFirstLastName`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      },
      body: JSON.stringify({
        firstName: firstName,
        lastName: lastName
      }),
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else {
      // Return status code for non-ok responses (as per original code)
      return response.status;
    }
  } catch (error) {
   
    throw new Error(`Error getting contacts by name: ${error.message}`);
  }
};

export const getContactsViaQuickSearch = async (query, pageNumber = 1, pageSize = 100, includeFullDetails = true) => {
  try {
    if (!query) {
      throw new Error('Query is required');
    }

    const queryBody = {
      "nameOrCommunicationDetailOrAddress": query.toString(),
      "pageNumber": pageNumber,
      "pageSize": pageSize,
      "includeFullDetails": includeFullDetails
    };

    const response = await authenticatedFetch(`${config.API_BASE_URL}/quick-contacts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      },
      body: JSON.stringify(queryBody),
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else {
      // Return status code for non-ok responses (as per original code)
      return response.status;
    }
  } catch (error) {
   
    throw new Error(`Error in quick search: ${error.message}`);
  }
};

// Additional helper functions for better error handling and convenience

export const searchContacts = async (searchTerm) => {
  try {
    // Try quick search first
    const result = await getContactsViaQuickSearch(searchTerm);
    return result;
  } catch (error) {
   
    throw error;
  }
};

// Utility function to check if a contact search result is valid
export const isValidContactResult = (result) => {
  return result && typeof result === 'object' && !Number.isInteger(result);
};

// Example usage with React hooks
export const useContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchContacts = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getContacts();
      setContacts(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const searchContactsHook = async (query) => {
    setLoading(true);
    setError(null);
    try {
      const result = await getContactsViaQuickSearch(query);
      if (isValidContactResult(result)) {
        setContacts(result);
      } else {
        setError('No contacts found');
        setContacts([]);
      }
    } catch (err) {
      setError(err.message);
      setContacts([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    contacts,
    loading,
    error,
    fetchContacts,
    searchContacts: searchContactsHook,
  };
};